exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon{width:2em;height:2em;margin-right:10px}#app .dropdown li a{padding:10px 20px;display:flex;width:100%;align-items:center;font-size:1.25em}.selected .icon{max-height:23px;max-width:23px}button.clear{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a6d7ac5","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 210
// module chunks = 0